import { allRoles, administratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/account";

/**
 * The accounts list. Paged by the search endpoint, so nothing is read until a filter is
 * submitted, as on the legacy table and the contacts list.
 */
export const accountsListDefinition: ListDefinition = {
  path: "/accounts",
  entityName: "account",
  recordRoute,
  title: "Accounts",
  allowedRoles: allRoles,
  data: "search-paged",
  // In the legacy page's order; Created On sits behind Advanced filters, as on contacts.
  filters: [
    {
      name: "emailaddress1",
      label: "Email Address",
      kind: "text",
      width: "wider",
    },
    { name: "name", label: "Name", kind: "text" },
    { name: "postalcode", label: "Postal Code", kind: "text" },
    {
      name: "createdon",
      label: "Created",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterDescription:
    "When searching by email address, this must be an exact match.",
  filterByStatus: true,
  allowAdd: true,
  addRoles: administratorRoles,
  allowStatusEdit: true,
  statusRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "emailaddress1",
      label: "Email Address",
      width: 300,
      sortable: true,
    },
    {
      key: "address1_postalcode",
      label: "Postal Code",
      width: 200,
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
